// project imports
import gestopAPI from 'utils/gestopAPI';
import { errorProcessor } from 'utils/processors';

export const ApiProfileSettingsPostCollection = async ({
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('admin/profilesettings', data, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiProfileSettingsDeleteCollection = async ({
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('admin/profilesettings/delete', ids, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiProfileSettingsPutItem = async ({ id, data = {}, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    await gestopAPI
        .put(`admin/profilesettings/${id}`, data, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiProfileSettingsPatchItem = async ({ id, data = {}, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    await gestopAPI
        .patch(`admin/profilesettings/${id}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'application/merge-patch+json' }
        })
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiProfileSettingsDeleteItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    await gestopAPI
        .delete(`admin/profilesettings/${id}`, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};
